import TableTemplate from "../../TableTemplate/tableTemplate";
import { useAppDispatch } from "../../../App/hooks";
import { setStepAddOrderFormValues } from "../../../Features/Step/stepSlice";
import {
  IStepAddOrderFormValues,
  IStepTablesSearchParam,
  IStepTradeTableReport,
} from "../../../Interfaces/stepInterfaces";
import {
  getStepAggregatedTradeTable,
  getStepTradeAggregateExcelFile,
  getStepTradeExcelFile,
  getStepTradeTable,
} from "../../../Requests/stepRequests";
import StepTradeTableUI from "./StepTradeTableUI";
import ExpandableButton from "../../../Components/ExpandableButton";
import FileDownloader from "../../../Components/FileDownloader";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { store } from "../../../App/store";
import { useState } from "react";
import CheckBox from "../../../Components/Checkbox";
import StepAggregateTradeTable from "../StepAggregatedTrade/StepAggregatedTradeTable";

interface TradeTableProps {
  searchParam: IStepTablesSearchParam;
}

const StepTradeTable = ({ searchParam }: TradeTableProps) => {
  const [isAggregate, setIsAggregate] = useState(false);
  const dispatch = useAppDispatch();

  const onTableRowClick = (row: IStepTradeTableReport) => {
    dispatch(
      setStepAddOrderFormValues({
        ...store.getState().step.addOrderFormValues,
        orderSide: row.orderSide,
        instrumentType: row.instrumentType,
        instrumentId: row.instrument,
      } as IStepAddOrderFormValues)
    );
  };

  return (
    <div className="flex flex-col gap-3 justify-start items-end w-full trade-table">
      <div className="flex flex-row justify-start items-center absolute -left-28 -top-10 gap-3">
        <CheckBox
          label="تجمیعی"
          checked={isAggregate}
          name=""
          onChange={(_, v) => {
            setIsAggregate(v);
          }}
        />
        <div>
          <ExpandableButton
            toolButton
            title="دانلود فایل"
            btnVariant="outlined"
            children={[
              <FileDownloader getFile={() => getStepTradeExcelFile(searchParam)} label="Excel" variant="menu" />,
              <FileDownloader getFile={() => getStepTradeAggregateExcelFile(searchParam)} label="Excel تجمیعی" variant="menu" />,
            ]}
            text={<FileDownloadOutlinedIcon fontSize="small" />}
          />
        </div>
      </div>
      {isAggregate ? (
        <StepAggregateTradeTable searchParam={searchParam} />
      ) : (
        <TableTemplate<IStepTablesSearchParam, IStepTradeTableReport>
          refreshTableTime={5000}
          getDataTable={(searchParam, offset, pageSize, sortingType) =>
            getStepTradeTable(searchParam, offset, pageSize, sortingType || "")
          }
          withSort
          TableUI={({ reports, onAction, setSortingType, sortingType }) => (
            <StepTradeTableUI
              reports={reports}
              onAction={onAction}
              onTableRowClick={onTableRowClick}
              sortingType={sortingType}
              setSortingType={setSortingType}
            />
          )}
          searchParameters={searchParam}
          showPageSize
        />
      )}
    </div>
  );
};

export default StepTradeTable;
